export const createEntitySystemMutation = (
    entityId: number, systemId: number, integrationType: string, isRequiredDaily: boolean, isGenerateIpe: boolean = true, forceGenerate: string | null = null
) => {
    const forceGenerateArg = forceGenerate ? `, forceGenerate: ${JSON.stringify(forceGenerate)}` : ''
    return `mutation {
            createEntitySystem(
                entityId: ${entityId},
                systemId: ${systemId},
                integrationType: "${integrationType}",
                isRequiredDaily: ${isRequiredDaily},
                isGenerateIpe: ${isGenerateIpe}${forceGenerateArg}
            ) {
                entitySystem {
                    id
                    system {
                        id
                        name
                    }
                    isGenerateIpe
                    forceGenerate
                }
            }
        }
    `;
}